/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable complexity */
/* eslint-disable unicorn/no-null */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable prettier/prettier */
/* eslint-disable dot-notation */
/* eslint-disable prefer-const */
/**
 * @file Activators
 *
 * Activators page related components initialization
 */
import Modal from '../../components/Modal';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import VenueSearchV2 from '../../components/VenueSearchV2';
import AddressSearch from '../../components/AddressSearch';
import Request from '../../utils/request';
class Activators {
	constructor() {
		this._wrapper = SelectorEngine.findOne('#activators-modal');
		if (!this._wrapper) {
			return;
		}

		this.state = {
			section: 0,
			isActivatorOnboardingCompleted: false,
			orgId: '',
			selectedVenue: undefined,
			activatorType: '',
			pointofContactOperators: '',
			leisureOperators: '',
			phoneNumber: '',
			deliveryFirstName: SelectorEngine.findOne('#activators-data-attr').getAttribute('data-first-name'),
			deliveryLastName: SelectorEngine.findOne('#activators-data-attr').getAttribute('data-last-name')
		};
		this._modal = undefined;
		this._sections = undefined;
		this._stepSections = undefined;
		this._isRecommended = false;
		this._modalTriggerSSBtn = undefined;
		this._stepState = { stepItem: false };
		this.initiateSection();
	}

	initiateSection() {
		const defultModal = document.querySelector('#activators-default-modal');
		const mainModal = document.querySelector('#activators-modal');
		const succesContainer = document.querySelector('#activators-modal-success');

		this._defaultsModal = new Modal(defultModal, {});
		this._modal = new Modal(mainModal, {});
		this._successModal = new Modal(succesContainer, {});

		this._modalTriggerSSBtn = SelectorEngine.findOne('.js-trigger-activators');
		this.startActivatorsJourney = SelectorEngine.findOne('.activators-onboarding-journey');
		const nextSectionCtas = SelectorEngine.find('.js-next-section', this._wrapper);
		this.previousCtas = SelectorEngine.find('.js-activators-back', this._wrapper);
		// if (this.state.section == 0) {
		// 	this.previousCtas[0].classList.add('u-hidden');
		// }
		this._sections = SelectorEngine.find('.content-container', this._wrapper);
		this._stepSections = SelectorEngine.find('.steps-container', this._wrapper);
		this.next1btn = SelectorEngine.findOne('.next-one', this._wrapper);
		this.next2btn = SelectorEngine.findOne('.next-two', this._wrapper);
		this.next3btn = SelectorEngine.findOne('.next-three', this._wrapper);
		const forms = SelectorEngine.find('.lta-content--form-element', this._wrapper);
		const submitOnboarding = SelectorEngine.findOne('.js-complete-onboarding', this._wrapper);
		this.submitOnboardingSection2 = SelectorEngine.findOne('.js-complete-onboarding-section2', this._wrapper);
		this.otherOrganisationName = SelectorEngine.findOne('#organisation_name', this._wrapper);
		this.otherActivatorTypeName = SelectorEngine.findOne('#activatorType_name', this._wrapper);
		this.errorContainer = SelectorEngine.findOne('.activator-onboarding__cancellation-error', mainModal);
		this.dismissError = SelectorEngine.findOne('.js-activator-dismiss', mainModal);
		this.venueContainer = SelectorEngine.findOne('.venue-container', this._wrapper);
		this.venueAddressContainer = SelectorEngine.findOne('.venue-address-container', this._wrapper);
		this.cantFindVenueBtn = SelectorEngine.findOne('.lta-activator-cannot-find-venue', this._wrapper);
		this.searchVenueBtn = SelectorEngine.findOne('.lta-activator-search-venue', this._wrapper);

		this.activatorsVenueSearchEl =
			VenueSearchV2.getInstance(document.querySelector('.lta-venue-ss-search-v2.js-venue-search-v2')) ||
			new VenueSearchV2(document.querySelector('.lta-venue-ss-search-v2.js-venue-search-v2'));

		this.activatorsVenueAddressSearchEl =
			AddressSearch.getInstance(document.querySelector('.lta-address-search.js-venue-address')) ||
			new AddressSearch(document.querySelector('.lta-address-search.js-venue-address'));

		this.activatorsVenueSearchEl.onChange((e) => {
			let activatorType = SelectorEngine.findOne('input[name = "activatorType"]:checked', this._wrapper);
			if (e === 'addVenue') {
				if (activatorType?.id == 'serves_organisation') {
					this.next2btn.classList.add('u-hidden');
					this.next2btn.disabled = true;
					this.submitOnboardingSection2.classList.remove('u-hidden');
				} else {
					this.next2btn.classList.remove('u-hidden');
					this.next2btn.disabled = false;
					this.submitOnboardingSection2.classList.add('u-hidden');
				}

				if (this.activatorsVenueSearchEl.state.venues.length > 0) {
					let venueDetails = {};
					venueDetails['venueId'] = this.activatorsVenueSearchEl.state.venues[0].orgid;
					venueDetails['name'] = this.activatorsVenueSearchEl.state.venues[0].name;
					venueDetails['venueStreet'] = this.activatorsVenueSearchEl.state.venues[0].address.street;
					venueDetails['venueCity'] = this.activatorsVenueSearchEl.state.venues[0].address.city;
					venueDetails['venuePostalCode'] = this.activatorsVenueSearchEl.state.venues[0].address.postalcode;
					venueDetails['venueCountry'] = this.activatorsVenueSearchEl.state.venues[0].address.country;
					this.state.selectedVenue = venueDetails;
				}
			} else if (e === 'removeVenue') {
				this.state.selectedVenue = undefined;
				this.next2btn.classList.add('u-hidden');
				this.next2btn.disabled = true;
				this.submitOnboardingSection2.classList.add('u-hidden');
			}
		});

		this.activatorsVenueAddressSearchEl.onChange((e) => {
			let activatorType = SelectorEngine.findOne('input[name = "activatorType"]:checked', this._wrapper);
			if (e === 'addAddress') {
				if (activatorType?.id == 'serves_organisation') {
					this.next2btn.classList.add('u-hidden');
					this.next2btn.disabled = true;
					this.submitOnboardingSection2.classList.remove('u-hidden');
				} else {
					this.next2btn.classList.remove('u-hidden');
					this.next2btn.disabled = false;
					this.submitOnboardingSection2.classList.add('u-hidden');
				}

				if (Object.keys(this.activatorsVenueAddressSearchEl.state.address).length > 0) {
					let address = {};
					address['venueId'] = '';
					address['name'] = this.activatorsVenueAddressSearchEl.state.address.street.includes(',')
						? this.activatorsVenueAddressSearchEl.state.address.street.split(',')[0].trim()
						: this.activatorsVenueAddressSearchEl.state.address.street;
					address['venueStreet'] = this.activatorsVenueAddressSearchEl.state.address.street.includes(',')
						? this.activatorsVenueAddressSearchEl.state.address.street.split(',')[1].trim()
						: this.activatorsVenueAddressSearchEl.state.address.street;
					address['venueCity'] = this.activatorsVenueAddressSearchEl.state.address.city;
					address['venueCountry'] = this.activatorsVenueAddressSearchEl.state.address.country;
					address['venuePostalCode'] = this.activatorsVenueAddressSearchEl.state.address.postCode;
					this.state.selectedVenue = address;
				}
			} else if (e === 'removeAddress') {
				this.state.selectedVenue = [];
				this.next2btn.classList.add('u-hidden');
				this.next2btn.disabled = true;
				this.submitOnboardingSection2.classList.add('u-hidden');
			}
		});

		EventHandler.on(this.otherOrganisationName, 'change', (e) => {
			if (this.otherOrganisationName.value.length > 0) {
				this.state.leisureOperators = e.target.value;
				this.next1btn.classList.remove('u-hidden');
				this.next1btn.disabled = false;
				this.next1btn.scrollIntoView();
			} else {
				this.next1btn.classList.add('u-hidden');
				this.next1btn.disabled = true;
				this.next1btn.scrollIntoView();
			}
		});

		EventHandler.on(this.otherActivatorTypeName, 'change', (e) => {
			if (this.otherActivatorTypeName.value.length > 0) {
				this.state.activatorType = e.target.value;
				this.next1btn.classList.remove('u-hidden');
				this.next1btn.disabled = false;
				this.next1btn.scrollIntoView();
			} else {
				this.next1btn.classList.add('u-hidden');
				this.next1btn.disabled = true;
				this.next1btn.scrollIntoView();
			}
		});

		EventHandler.on(this._modalTriggerSSBtn, 'click', () => {
			this._defaultsModal.show();
		});

		EventHandler.on(this.startActivatorsJourney, 'click', () => {
			this._defaultsModal.hide();
			this._modal.show();
		});

		EventHandler.on(this.dismissError, 'click', () => {
			this.errorContainer.classList.add('u-hidden');
		});

		EventHandler.on(this.cantFindVenueBtn, 'click', () => {
			let venueContainer = SelectorEngine.findOne('.js-venue-activator-form', this._wrapper);
			let removeVenueBtn = SelectorEngine.findOne('.lta-venue-ss-search--remove', venueContainer);
			if (removeVenueBtn) {
				removeVenueBtn.click();
			}
			this.cantFindVenueBtn.classList.add('u-hidden');
			this.searchVenueBtn.classList.remove('u-hidden');
			this.venueContainer.classList.add('u-hidden');
			this.venueAddressContainer.classList.remove('u-hidden');
		});

		EventHandler.on(this.searchVenueBtn, 'click', () => {
			this.searchVenueBtn.classList.add('u-hidden');
			this.cantFindVenueBtn.classList.remove('u-hidden');
			this.venueAddressContainer.classList.add('u-hidden');
			this.venueContainer.classList.remove('u-hidden');
		});

		nextSectionCtas &&
			nextSectionCtas.forEach((cta) => {
				EventHandler.on(cta, 'click', (event) => {
					event.preventDefault();
					this.goToNextSection();
				});
			});

		this.previousCtas &&
			this.previousCtas[0].addEventListener('click', () => {
				if (this.state.section === 0) {
					this._modal.hide();
					this._defaultsModal.show();
				} else {
					this.previousCtas[0].disabled = false;
					this.goToPreviousSection();
				}
			});

		forms &&
			forms.forEach((form) => {
				form.addEventListener('change', () => {
					this._openHiddenSections();
				});
			});

		EventHandler.on(submitOnboarding, 'click', () => {
			this._finalSubmission(submitOnboarding);
		});

		EventHandler.on(this.submitOnboardingSection2, 'click', () => {
			this._finalSubmission(this.submitOnboardingSection2);
		});
	}

	async _finalSubmission(submitBtn) {
		submitBtn.disabled = true;
		let activatorType = SelectorEngine.findOne('input[name = "activatorType"]:checked', this._wrapper);
		const activatorData = Object.assign(
			{},
			{
				activatorType: this.state.activatorType,
				leisureOperators: this.state.leisureOperators,
				pointofContactOperators: this.state.pointofContactOperators,
				isActivatorOnboardingCompleted: this.state.isActivatorOnboardingCompleted,
				deliveryFirstName: activatorType?.id == 'serves_organisation' ? '' : this.state.deliveryFirstName,
				deliveryLastName: activatorType?.id == 'serves_organisation' ? '' : this.state.deliveryLastName,
				VenueDetails: this.state.selectedVenue
			}
		);
		const data = await Request.post('/api/membership/activator/submit', activatorData).catch(() => {
			submitBtn.disabled = false;
			this.errorContainer.classList.remove('u-hidden');
		});

		if (data?.StatusCode == '02') {
			this._defaultsModal.hide();
			this._modal.hide();
			this._successModal.show();
		} else {
			submitBtn.disabled = false;
			this.errorContainer.classList.remove('u-hidden');
		}
	}

	_updateVenues() {
		this.cantFindVenueBtn.classList.add('u-hidden');
		this.next2btn.classList.remove('u-hidden');
		this.next2btn.disabled = false;
		this.next2btn.scrollIntoView();
	}

	_openHiddenSections() {
		const currentPosition = this.state.section;
		if (currentPosition == 0) {
			let activatorType = SelectorEngine.findOne('input[name = "activatorType"]:checked', this._wrapper);
			let organisationName = SelectorEngine.findOne('input[name = "organisation"]:checked', this._wrapper);
			let pointOfContact = SelectorEngine.findOne('input[name = "pointOfContact"]:checked', this._wrapper);
			if (activatorType) {
				this.state.activatorType = activatorType.value;
				if (activatorType?.id == 'other_activator') {
					SelectorEngine.findOne('.organisation-type', this._wrapper).classList.add('u-hidden');
					SelectorEngine.findOne('.point-of-contact-type', this._wrapper).classList.add('u-hidden');
					SelectorEngine.findOne('.other-organisation-container', this._wrapper).classList.add('u-hidden');
					SelectorEngine.findOne('#organisation_name', this._wrapper).value = '';
					if (organisationName && organisationName.checked) {
						organisationName.checked = false;
					}
					if (pointOfContact && pointOfContact.checked) {
						pointOfContact.checked = false;
					}
					SelectorEngine.findOne('.other-activatorType-container', this._wrapper).classList.remove('u-hidden');
					if (this.otherActivatorTypeName.value.length > 0) {
						this.state.activatorType = this.otherActivatorTypeName.value;
						this.next1btn.classList.remove('u-hidden');
						this.next1btn.disabled = false;
					} else {
						this.next1btn.classList.add('u-hidden');
						this.next1btn.disabled = true;
					}
				} else if (activatorType?.id == 'serves_organisation') {
					SelectorEngine.findOne('.other-activatorType-container', this._wrapper).classList.add('u-hidden');
					SelectorEngine.findOne('.organisation-type', this._wrapper).classList.add('u-hidden');
					SelectorEngine.findOne('.other-organisation-container', this._wrapper).classList.add('u-hidden');
					SelectorEngine.findOne('#activatorType_name', this._wrapper).value = '';
					SelectorEngine.findOne('#organisation_name', this._wrapper).value = '';
					SelectorEngine.findOne('.point-of-contact-type', this._wrapper).classList.remove('u-hidden');
					if (organisationName && organisationName.checked) {
						organisationName.checked = false;
					}
					if (pointOfContact == null) {
						this.next1btn.classList.add('u-hidden');
						this.next1btn.disabled = true;
					} else {
						this.state.pointofContactOperators = pointOfContact.value;
						this.next1btn.classList.remove('u-hidden');
						this.next1btn.disabled = false;
					}
				} else if (activatorType?.id == 'leisure_centre') {
					SelectorEngine.findOne('.other-activatorType-container', this._wrapper).classList.add('u-hidden');
					SelectorEngine.findOne('.point-of-contact-type', this._wrapper).classList.add('u-hidden');
					SelectorEngine.findOne('#activatorType_name', this._wrapper).value = '';
					SelectorEngine.findOne('.organisation-type', this._wrapper).classList.remove('u-hidden');
					if (pointOfContact && pointOfContact.checked) {
						pointOfContact.checked = false;
					}
					if (organisationName?.id == 'other') {
						SelectorEngine.findOne('.other-organisation-container', this._wrapper).classList.remove('u-hidden');
						if (this.otherOrganisationName.value.length > 0) {
							this.state.leisureOperators = this.otherOrganisationName.value;
							this.next1btn.classList.remove('u-hidden');
							this.next1btn.disabled = false;
						} else {
							this.next1btn.classList.add('u-hidden');
							this.next1btn.disabled = true;
						}
					} else if (organisationName == null) {
						SelectorEngine.findOne('.other-organisation-container', this._wrapper).classList.add('u-hidden');
						SelectorEngine.findOne('#organisation_name', this._wrapper).value = '';
						this.next1btn.classList.add('u-hidden');
						this.next1btn.disabled = true;
					} else {
						this.state.leisureOperators = organisationName.value;
						SelectorEngine.findOne('.other-organisation-container', this._wrapper).classList.add('u-hidden');
						SelectorEngine.findOne('.other-organisation-container', this._wrapper).classList.add('u-hidden');
						SelectorEngine.findOne('#organisation_name', this._wrapper).value = '';
						this.next1btn.classList.remove('u-hidden');
						this.next1btn.disabled = false;
					}
				} else {
					SelectorEngine.findOne('.organisation-type', this._wrapper).classList.add('u-hidden');
					SelectorEngine.findOne('.point-of-contact-type', this._wrapper).classList.add('u-hidden');
					if (organisationName && organisationName.checked) {
						organisationName.checked = false;
					}
					if (pointOfContact && pointOfContact.checked) {
						pointOfContact.checked = false;
					}
					SelectorEngine.findOne('.other-organisation-container', this._wrapper).classList.add('u-hidden');
					SelectorEngine.findOne('#organisation_name', this._wrapper).value = '';
					SelectorEngine.findOne('.other-activatorType-container', this._wrapper).classList.add('u-hidden');
					SelectorEngine.findOne('#activatorType_name', this._wrapper).value = '';
					this.next1btn.classList.remove('u-hidden');
					this.next1btn.disabled = false;
					this.next1btn.scrollIntoView();
				}
			}
		}
	}

	exitJourney() {
		this._modalTriggerSSBtn.disabled = true;
		this._defaultsModal.hide();
		this._modal.hide();
		if (this.state.isSubmitted) {
			setTimeout(() => location.reload(true), 300);
		}
	}

	resetJourney() {
		const currentPosition = this.state.section;
		if (currentPosition !== 0) {
			this._sections[0].children.item(currentPosition).classList.add('u-hidden');
			this._sections[0].children.item(0).classList.remove('u-hidden');
			this.state.section = 0;
		}

		this._sections.forEach((section) => {
			const parts = section.querySelectorAll('.js-lta-section-content');
			parts.forEach((part, i) => {
				if (i === 0) {
					part.classList.remove('u-hidden');
				} else {
					part.classList.add('u-hidden');
				}
			});
		});

		sessionStorage.ltaOnboardingExit = true;
	}

	goToNextSection() {
		const currentPosition = this.state.section;
		let activatorType = SelectorEngine.findOne('input[name = "activatorType"]:checked', this._wrapper);
		if (currentPosition + 1 < this._sections[0].children.length) {
			if (currentPosition == 0) {
				const currentStepSection = this._stepSections[0].children
					.item(currentPosition + 1)
					.querySelectorAll('.lta-steps__item'); //To remove third step from the steps container as serves_organisation have only 2questions.
				
				if (this._stepState.stepItem) {
					currentStepSection[currentStepSection.length - 1].classList.remove('u-hidden');
					this._stepState.stepItem = false;
				}
				this.submitOnboardingSection2.classList.add('u-hidden');
				if (this.activatorsVenueSearchEl.state.venues.length > 0) {
					this.next2btn.classList.remove('u-hidden');
				} else {
					this.next2btn.classList.add('u-hidden');
				}
				this.next2btn.disabled = false;
				
				this._sections[0].children.item(currentPosition + 1).classList.add('u-hidden');
				this._stepSections[0].children.item(currentPosition).classList.add('u-hidden');
				this._stepSections[0].children.item(currentPosition + 1).classList.remove('u-hidden');
				this._sections[0].children.item(currentPosition + 2).classList.remove('u-hidden');
				this._sections[0].children.item(currentPosition + 1).scrollIntoView();
				this.state.section = currentPosition + 1;
			} else if (currentPosition == 1) {
				if (
					activatorType.id == 'girl_guides' ||
					activatorType.id == 'scouts' ||
					activatorType.id == 'other_activator'
				) {
					this._sections[0].children.item(currentPosition + 1).classList.add('u-hidden');
					this._stepSections[0].children.item(currentPosition).classList.add('u-hidden');
					this._stepSections[0].children.item(currentPosition + 1).classList.remove('u-hidden');
					this._sections[0].children.item(currentPosition + 2).classList.remove('u-hidden');
					this._sections[0].children.item(currentPosition + 2).children[0].classList.remove('u-hidden');
					this._sections[0].children.item(currentPosition + 2).children[1].classList.add('u-hidden');
					this._sections[0].children.item(currentPosition + 1).scrollIntoView();
					this.state.section = currentPosition + 1;
				} else if (activatorType.id == 'leisure_centre') {
					let canDelivered = SelectorEngine.findOne('input[name = "canDeliver"]:checked', this._wrapper);
					if (canDelivered !== null && canDelivered.checked == true) {
						canDelivered.checked = false;
						this.next3btn.classList.add('u-hidden');
					}
					this._sections[0].children.item(currentPosition + 1).classList.add('u-hidden');
					this._stepSections[0].children.item(currentPosition).classList.add('u-hidden');
					this._stepSections[0].children.item(currentPosition + 1).classList.remove('u-hidden');
					this._sections[0].children.item(currentPosition + 2).classList.remove('u-hidden');
					this._sections[0].children.item(currentPosition + 2).children[0].classList.add('u-hidden');
					this._sections[0].children.item(currentPosition + 2).children[1].classList.remove('u-hidden');
					this._sections[0].children.item(currentPosition + 1).scrollIntoView();
					this.state.section = currentPosition + 2;
				} else {
					this._sections[0].children.item(currentPosition + 1).classList.add('u-hidden');
					this._stepSections[0].children.item(currentPosition).classList.add('u-hidden');
					this._stepSections[0].children.item(currentPosition + 2).classList.remove('u-hidden');
					this._sections[0].children.item(currentPosition + 3).classList.remove('u-hidden');
					this._sections[0].children.item(currentPosition + 2).scrollIntoView();
					this.state.section = currentPosition + 2;
				}
			} else if (currentPosition == 2) {
				this._sections[0].children.item(currentPosition + 1).classList.remove('u-hidden');
				if (activatorType?.id === 'serves_organisation') {
					this._sections[0].children.item(currentPosition + 1).children[0].classList.remove('u-hidden');
					this._sections[0].children.item(currentPosition + 1).children[1].classList.add('u-hidden');
				} else {
					this._sections[0].children.item(currentPosition + 1).children[1].classList.remove('u-hidden');
					this._sections[0].children.item(currentPosition + 1).children[0].classList.add('u-hidden');
				}
				this._sections[0].children.item(currentPosition + 1).scrollIntoView();
				this.state.section = currentPosition + 1;
				if (this.state.section == 0) {
					this.previousCtas[0].classList.add('u-hidden');
				} else {
					this.previousCtas[0].classList.remove('u-hidden');
				}
			} else {
				this._sections[0].children.item(currentPosition + 1).classList.add('u-hidden');
				this._stepSections[0].children.item(currentPosition).classList.add('u-hidden');
				this._stepSections[0].children.item(currentPosition + 1).classList.remove('u-hidden');
				this._sections[0].children.item(currentPosition + 2).classList.remove('u-hidden');
				this._sections[0].children.item(currentPosition + 1).scrollIntoView();
				this.state.section = currentPosition + 1;
				if (this.state.section == 0) {
					this.previousCtas[0].classList.add('u-hidden');
				} else {
					this.previousCtas[0].classList.remove('u-hidden');
				}
			}
		}
	}

	goToPreviousSection() {
		const currentPosition = this.state.section;
		let allSections = document.querySelectorAll('.content-container .section');
		let allSteps = document.querySelectorAll('.steps-container .activators-steps');
		if (this.state.section == 3) {
			let activatorType = SelectorEngine.findOne('input[name = "activatorType"]:checked', this._wrapper);
			if (activatorType.id == 'girl_guides' || activatorType.id == 'scouts' || activatorType.id == 'other_activator') {
				this._sections[0].children.item(currentPosition).classList.remove('u-hidden');
				this._sections[0].children.item(currentPosition).children[0].classList.remove('u-hidden');
				this._sections[0].children.item(currentPosition).children[1].classList.add('u-hidden');
				this.state.section = this.state.section - 1;
			} else if (activatorType.id == 'leisure_centre') {
				let canDelivered = SelectorEngine.findOne('input[name = "canDeliver"]:checked', this._wrapper);
				if (canDelivered !== null && canDelivered.checked == true) {
					canDelivered.checked = false;
					this.next3btn.classList.add('u-hidden');
				}
				this._sections[0].children.item(currentPosition).classList.add('u-hidden');
				this._stepSections[0].children.item(currentPosition - 1).classList.add('u-hidden');
				this._stepSections[0].children.item(currentPosition - 2).classList.remove('u-hidden');
				this._sections[0].children.item(currentPosition - 1).classList.remove('u-hidden');
				this._sections[0].children.item(currentPosition - 1).children[0].classList.remove('u-hidden');
				this._sections[0].children.item(currentPosition - 1).scrollIntoView();
				this.state.section = currentPosition - 2;
			} else {
				this._sections[0].children.item(currentPosition).classList.remove('u-hidden');
				this._sections[0].children.item(currentPosition).children[1].classList.add('u-hidden');
				this._sections[0].children.item(currentPosition).children[0].classList.remove('u-hidden');
				allSteps[this.state.section].classList.add('u-hidden');
				allSteps[this.state.section - 2].classList.remove('u-hidden');
				this.state.section = this.state.section - 1;
			}
		} else {
			allSections[this.state.section].classList.add('u-hidden');
			allSections[this.state.section - 1].classList.remove('u-hidden');
			allSteps[this.state.section].classList.add('u-hidden');
			allSteps[this.state.section - 1].classList.remove('u-hidden');
			this.state.section = this.state.section - 1;
		}
	}
}

const activators = new Activators();

export default activators;
